import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { getManagerById, saveManager, updateManager } from "../Services/Manager";
import { useNavigate, useParams } from "react-router-dom";
import { uploadImage } from "../Services/Therapist";

const Edit_CaseManager = () => {
    const [loder, setLoder] = useState(false)

    const Swal = require('sweetalert2')
    const navigate = useNavigate();
    let { id } = useParams();

    const { register, handleSubmit, reset, watch, formState: { errors } } = useForm();
    // previous pic
    const [pPicture, setPPicture] = useState()
    // for image
    const [picture, setPicture] = useState(null)
    const [imgData, setImgData] = useState()
    const imagesPreview = (e) => {
        if (e.target.files[0]) {
            setPicture(e.target.files[0])
            const reader = new FileReader()
            reader.readAsDataURL(e.target.files[0])
            reader.addEventListener("load", () => {
                setImgData(reader.result)
            })
        }
    }

    const onSubmit = async (formData) => {
        setLoder(true)

        const data = {
            caseManagerId: id,
            name: formData.name,
            email: formData.email,
            profilePicture: ""
        }
        // upload img
        // debugger
        if (picture !== null) {
            const formData1 = new FormData();
            formData1.append("", picture);
            const imageResponse = await uploadImage(formData1);
            data.profilePicture = imageResponse.data.data.url;
        } else {
            data.profilePicture = pPicture;
        }

        const resp = await updateManager(data)
        if (resp.data.code === 1) {
            Swal.fire({
                title: 'Case Manager Updated!',
                timer: 1400,
                icon: 'success',
                showConfirmButton: false,
            })
            setTimeout(() => {
                navigate("/manage-case-manager");
            }, 2000);
        }
    }

    const getManager = async () => {
        const resp = await getManagerById(id);
        setPPicture(resp?.data?.data?.profilePicture)
        reset(resp.data.data)
    }

    useEffect(() => {
        getManager()
    }, [])



    return (
        <div className="mainDashboard side_dashboard_container">
            <div className="row">
                <div className="col-md-12">
                    <Link to="/manage-case-manager" className="dashboardHeading arrowbefore">
                        <img src="/assets/images/Icon ionic-ios-arrow-back.svg" alt="" />
                        <h2>Edit Case Manager</h2>
                    </Link>
                </div>
            </div>
            <div className="users-table set3">
                <div className="users-table-container">
                    <div className="user-table-head">
                        <div className="userHeading">
                            <h2>Case Manager Details</h2>
                        </div>
                    </div>
                    <div>
                        {imgData ? <img className='userImgSiZe' src={imgData} alt='' /> :
                            <>
                                <div className='uploadBtnUser1'>
                                    <img className='userImgSiZe' src={pPicture ?? "/assets/images/user Detail Image1.png"} alt="" />
                                    <input onChange={imagesPreview} type="file" accept='image/*' />
                                </div>
                            </>
                        }
                    </div>
                    <form className="form-login setManagerField" style={{ marginTop: "unset" }}>
                        <div className="therapist_category">
                            <input type="text" {...register("name", { required: true })} placeholder="Therapist Name" />
                            <span className="error">{errors.name?.type === 'required' && "Therapist Name is required"}</span>
                        </div>
                        <div className="therapist_name" style={{ marginLeft: '40px' }}>
                            <input type="email" {...register("email", { required: true })} placeholder="Therapist email" />
                            <span className="error">{errors.email?.type === 'required' && "Therapist email is required"}</span>
                        </div>
                    </form>
                </div>
            </div>
            <div className="buttonSet">
                <Link className="bttn setb" to="/manage-case-manager">Cancel</Link>
                {
                    (loder === true) ?
                        <div className="relative">
                            <div className="loader alignAdd userLodrgg"></div>
                            <Link style={{ display: "block" }} to="" className="bttn bttn-bg" >Update</Link>
                        </div>
                        :
                        <Link className="bttn bttn-bg" onClick={handleSubmit(onSubmit)} to="">Update</Link>
                }

            </div>
        </div>
    );
}

export default Edit_CaseManager;